import React from 'react';
import ProductAddContainer from '../../containers/productmng/ProductAddContainer';

const ProductAddPage = () => {
 return <ProductAddContainer/>
};

export default ProductAddPage;
